module.exports = __webpack_public_path__ + "static/iba_game_2-6497571401b48121487b2187858b38d4.png";